import React from 'react';
import styled from 'styled-components';

interface ResizeHandleProps {
  onResizeStart: (clientX: number, clientY: number) => void;
}

const StyledHandle = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  bottom: 0;
  right: 0;
  cursor: se-resize;
  background-color: rgba(33, 150, 243, 0.1);
  z-index: 100;
  border-radius: 0 0 5px 0;
  touch-action: none;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 12px;
    height: 12px;
    border-right: 3px solid #2196f3;
    border-bottom: 3px solid #2196f3;
    opacity: 0.8;
    transition: all 0.15s ease;
  }
  
  &:hover {
    background-color: rgba(33, 150, 243, 0.2);
  }
  
  &:hover::after {
    opacity: 1;
    width: 14px;
    height: 14px;
  }
  
  &:active {
    background-color: rgba(33, 150, 243, 0.3);
  }
  
  &:active::after {
    border-right: 3px solid #0d47a1;
    border-bottom: 3px solid #0d47a1;
  }
`;

const ResizeHandle: React.FC<ResizeHandleProps> = ({ onResizeStart }) => {
  // マウスイベント用ハンドラ
  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    
    // クライアント座標を親コンポーネントに渡す
    onResizeStart(e.clientX, e.clientY);
  };
  
  // タッチイベント用ハンドラ
  const handleTouchStart = (e: React.TouchEvent) => {
    e.stopPropagation();
    
    // タッチイベントの場合は最初のタッチポイントの座標を使用
    if (e.touches.length > 0) {
      const touch = e.touches[0];
      onResizeStart(touch.clientX, touch.clientY);
    }
  };

  return (
    <StyledHandle 
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      title="ドラッグしてカードのサイズを変更"
    />
  );
};

export default ResizeHandle; 